import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { IGetReportPlanoQualidadeObraUseCase } from "../../../presentation/useCases/read/get_report_plano_qualidade_obra_use_case";
import { IReportsRepository } from "../../repositories/reports_repository";
import { ReportData } from "../../models/report_data";
import { ReportMimeType } from "../../../../../common/utils/report_callback";

import dayjs from "dayjs";

/**
 * GetReportPlanoQualidadeObraUseCase
 */

export class GetReportPlanoQualidadeObraUseCase implements IGetReportPlanoQualidadeObraUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportPlanoQualidadeObra(
    requiredMimeType: ReportMimeType | null,
    idObra: number,
  ): Promise<ReportData> {
    const response = await this.repository.getReportPlanoQualidadeObra(
      requiredMimeType,
      idObra,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `plano_qualidade_obra_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
